export const environment = {
  production: true,
  url: 'https://api.asiamerica.pe/',
  url_front: 'http://app.asiamerica.pe/',
  country: 'PE',
  url_prices_app: '-',
  url_open_factura: '-',
  api_token_open_factura: '1',
  url_asiascann: '-',
  debug: false,
};
